import styled from 'styled-components'

const TAB_HEADER_HEIGHT = 33

export const AiImageGenerateContainer = styled.section`
  width: 100%;
  /* height: calc(100% - ${TAB_HEADER_HEIGHT}px); */
  height: 100%;
  display: flex;
  flex-direction: column;
`
